// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1xwAW","colMaxWidth":"Table_colMaxWidth__389mC"};